/**
 * @generated SignedSource<<5ba1b2cb322284073c397217f7ac7215>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceOriginalImagesQuery$variables = {
  piece_id: string;
};
export type PieceOriginalImagesQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PieceOriginalImagesBody_piece">;
    };
  };
};
export type PieceOriginalImagesQuery = {
  variables: PieceOriginalImagesQuery$variables;
  response: PieceOriginalImagesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "piece_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PieceOriginalImagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PieceOriginalImagesBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PieceOriginalImagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "download_url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4f658f4c08b7fd00e258bdbb56d90937",
    "id": null,
    "metadata": {},
    "name": "PieceOriginalImagesQuery",
    "operationKind": "query",
    "text": "query PieceOriginalImagesQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    piece(id: $piece_id) {\n      id\n      ...PieceOriginalImagesBody_piece\n    }\n  }\n}\n\nfragment PieceOriginalImage_sheet on MusicSheet {\n  id\n  download_url\n}\n\nfragment PieceOriginalImagesBody_piece on MusicPiece {\n  sheets {\n    id\n    download_url\n    ...PieceOriginalImage_sheet\n  }\n}\n"
  }
};
})();

(node as any).hash = "e88a919a87e02864b33c50fdeb82351f";

export default node;
